<template>
  <div class="filter">
    <div
      class="FSFilterCombo no-select list-en"
      @click="toggleCombo"
      :class="{ FilterComboFocus: showMenu }"
      v-click-outside="closeCombo"
    >
      <div
        class="selected-text text-col"
        v-tooltip="{ content: this.selected, placement: 'left' }"
      >
        {{ selected }}
      </div>
      <div class="arrow-down-col" :class="{ open: showMenu }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.449"
          height="4.717"
          viewBox="0 0 7.449 4.717"
        >
          <g
            id="icon-arrow-combo"
            data-name="חץ לקומבחו"
            transform="translate(0.565 0.064)"
          >
            <path
              id="Path_23"
              data-name="Path 23"
              d="M127.4,52.591l2.654,2.885,2.675-2.907"
              transform="translate(-126.902 -51.573)"
              fill="none"
              stroke="#7b7b7b"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-miterlimit="10"
              stroke-width="1.5"
            />
          </g>
        </svg>
      </div>
      <div
        :class="{
          'open-menu': showMenu && !grid,
          'open-menu-grid': showMenu && grid,
          'option-items': !grid,
          'option-items-grid': grid,
        }"
      >
        <div
          v-for="item in itemsToShow"
          :key="item.labelKey"
          :class="{
            'combo-item': !grid,
            'combo-item-grid': grid,
            disable: !item.enabled,
          }"
          @click.stop="choose(item)"
        >
          <span :class="{ 'label-option': grid }"
            >{{ item.label }}
            <template
              v-if="
                item.labelKey == enumSearchInType.inMeforesh &&
                showSearchInMeforesh
              "
              :class="{ 'label-option': grid }"
              >{{ meforeshName }}</template
            ></span
          >
        </div>
        <div
          v-for="item in customList"
          :key="item.labelKey + item.label"
          class="custom-item flex flex-bet flex-align-center"
          :class="{
            'combo-item': !grid,
            'combo-item-grid': grid,
            disable: !item.enabled,
          }"
          @click.stop="choose(item)"
        >
          <span :class="{ 'label-option': grid }"
            >{{ item.label }}
            <template
              v-if="
                item.labelKey == enumSearchInType.inMeforesh &&
                showSearchInMeforesh
              "
              :class="{ 'label-option': grid }"
              >{{ meforeshName }}</template
            ></span
          >
          <span
            class="otz-icon icon-otz remove-item no-bg"
            @click.stop="removeItem(item.index)"
            >F</span
          >
        </div>
        <div class="combo-item border-t-light" @click.stop="addSearchInList">
          {{ this.$t("freeSearchInput.searchIn.addSearchList") }}
        </div>

        <listFSIn v-if="false" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import listFSIn from "./listFSIn.vue";
import { createFreeSearchBookListStore } from "@/store_pinia";
export default {
  components: {
    listFSIn,
  },
  props: {
    advancedPopup: {
      type: Boolean,
      default: false,
    },
    searchId: null,
  },
  data() {
    return {
      showMenu: false,
      grid: false,
      labelStart: 1,
      label: this.$t("freeSearchInput.searchIn.all"),
      labelKey: 1,
      customId: 0,
    };
  },
  computed: {
    ...mapGetters("systemFolders", ["getSystemMaagarim"]),
    ...mapState("freeSearch", ["enumSearchInType", "showAdvancedPopup"]),
    ...mapGetters("bookList", [
      "getDataOfCurrentList",
      "getTextSearchInput",
      "getCheckedBooks",
    ]),
    ...mapGetters("freeSearchBooklistComp", ["getListCheckBooksFree"]),
    freeSearchBookListStore() {
      return createFreeSearchBookListStore(this.searchId);
    },
    customListAdded() {
      return this.freeSearchBookListStore?.customListAdded || false;
    },
    customList() {
      return this.userSettings.settings.custom_search_in
        ? JSON.parse(this.userSettings.settings.custom_search_in).map(
            (c, i) => {
              return {
                label: c.name,
                labelKey: this.enumSearchInType.browse + i + 1,
                enabled: true,
                itemType: "custom",
                listId: c.id,
                listType: c.type,
                index: i,
              };
            }
          )
        : [];
      return [
        {
          label: "מקרא וחזל",
          labelKey: this.enumSearchInType.custom,
          enabled: true,
          itemType: "custom",
          listId: 102894,
          listType: 1,
        },
        {
          label: "מכון ירושלים",
          labelKey: this.enumSearchInType.custom,
          enabled: true,
          itemType: "custom",
          listId: 102900,
          listType: 1,
        },
        {
          label: "רשימה שלי",
          labelKey: this.enumSearchInType.custom,
          enabled: true,
          itemType: "custom",
          listId: 46,
          listType: 2,
        },
        {
          label: "רשימת חיפוש",
          labelKey: this.enumSearchInType.custom,
          enabled: true,
          itemType: "custom",
          listId: 49,
          listType: 3,
        },
      ];
    },
    items() {
      if (this.$_mobile) {
        return [
          {
            label: this.$t("freeSearchInput.searchIn.all"),
            labelKey: 1,
            enabled: true,
          },
          {
            label: this.$t("freeSearchInput.searchIn.current"),
            labelKey: 2,
            enabled: true,
          },
          {
            label: this.$t("freeSearchInput.searchIn.selected"),
            labelKey: 3,
            enabled: false,
          },

          {
            label: this.$t("freeSearchInput.searchIn.in"),
            labelKey: 4,
            enabled: true,
          },
        ];
      }
      return [
        {
          label: this.$t("freeSearchInput.searchIn.all"),
          labelKey: 1,
          enabled: true,
        },
        {
          label: this.$t("freeSearchInput.searchIn.current"),
          labelKey: 2,
          enabled: true,
        },
        {
          label: this.$t("freeSearchInput.searchIn.selected"),
          labelKey: 3,
          enabled: false,
        },

        {
          label: this.$t("freeSearchInput.searchIn.in"),
          labelKey: 4,
          enabled: true,
        },

        {
          label: this.$t("freeSearchInput.searchIn.siyun_maf"),
          labelKey: 5,
          enabled: true,
        },
        {
          label: this.$t("freeSearchInput.searchIn.browse"),
          labelKey: 6,
          enabled: true,
        },
      ];
    },
    hasCheckedBooks() {
      return (
        this.getCheckedBooks.length > 0 || this.getListCheckBooksFree.length > 0
      );
    },
    itemsToShow() {
      /*   let maagarim = this.getSystemMaagarim.map((m, i) => {
        return {
          label: m.title,
          labelKey: 7 + i,
          enabled: true,
          listId: m.id,
          type: "system-list",
        };
      }); */

      let items = this.items.filter((i) => {
        let a = !(
          (i.labelKey === this.enumSearchInType.tsiyunim &&
            this.advancedPopup) ||
          (i.labelKey == this.enumSearchInType.inMeforesh &&
            !this.showSearchInMeforesh)
        );

        return a;
      });

      return items;
    },
    showSearchInMeforesh() {
      return (
        this.getDataOfCurrentList.data.content.startsWith("מפרשים - ") ||
        this.getDataOfCurrentList.data.meforesh
      );
    },
    meforeshName() {
      if (
        !this.getDataOfCurrentList.data.meforesh ||
        this.getDataOfCurrentList.data.meforesh == false
      )
        return "";
    },
    selected() {
      this.labelKey = this.freeSearchBookListStore?.searchInType || 1;
      if (
        this.advancedPopup &&
        this.labelKey === this.enumSearchInType.tsiyunim
      )
        this.labelKey = this.enumSearchInType.all;

      if (this.labelKey > this.enumSearchInType.browse) {
        const custInx = this.customList.findIndex(
          (c) => c.labelKey == this.labelKey
        );

        return custInx > -1
          ? this.customList[custInx].label
          : this.items[0].label;
      }
      if (typeof this.items[this.labelKey - 1] === "undefined")
        return this.items[this.labelStart - 1].label;
      if (
        this.labelKey == this.enumSearchInType.browse &&
        this.freeSearchBookListStore?.savedListName != "" &&
        this.freeSearchBookListStore?.savedListName != undefined
      )
        return this.freeSearchBookListStore?.savedListName;

      return this.items[this.labelKey - 1].label;
    },
  },
  methods: {
    ...mapActions("folders", [
      "setOpenTypePopup",
      "setListType",
      "togglePopupFolder",
      "setBrowseType",
    ]),
    ...mapActions("userSetting", ["removeCustomSearchIn"]),
    removeItem(index) {
      this.removeCustomSearchIn(index);
    },
    openCombo() {
      this.showMenu = true;
    },
    toggleCombo() {
      if (this.showMenu) this.showMenu = false;
      else this.showMenu = true;
    },
    closeCombo() {
      this.showMenu = false;
    },
    async addSearchInList() {
      await this.setBrowseType("add");
      this.browseFolders();
    },
    async choose(item) {
      if (item.enabled) {
        this.label = item.label;
        this.labelKey = item.labelKey;

        this.freeSearchBookListStore.setSearchInType(item.labelKey);
        let prev =
          item.labelKey === this.enumSearchInType.browse
            ? this.enumSearchInType.all
            : item.labelKey;
        this.freeSearchBookListStore.setPrevSearchInType(prev);
        switch (item.labelKey) {
          case this.enumSearchInType.all:
            break;

          case this.enumSearchInType.selected:
            break;

          case this.enumSearchInType.inMeforesh:
            break;

          case this.enumSearchInType.browse:
            this.freeSearchBookListStore.savedListName = "";
            await this.setBrowseType("search");
            this.browseFolders();
            break;

          default:
            let typeAttr;
            switch (item.listType) {
              case 1:
                typeAttr = "system";
                break;
              case 2:
                typeAttr = "book";
                break;
              case 3:
                typeAttr = "free";
                break;
              case 4:
                typeAttr = "basic";
                break;
              case 5:
                typeAttr = "meforesh";
                break;
              case 6:
                typeAttr = "subjects";
                break;
            }

            this.freeSearchBookListStore.setBooksToSearchIn({
              id: item.listId,
              [typeAttr]: true,
            });
            break;
        }
        this.closeCombo();
      }
    },
    browseFolders() {
      this.setOpenTypePopup("browse").then(() => {
        this.setListType("all").then(() => {
          this.togglePopupFolder(true);
        });
      });
    },
  },
  watch: {
    customListAdded: function (v, o) {
      this.$nextTick(() => {
        if (this.customList.length === 0) return;
        this.choose(this.customList[this.customList.length - 1]);
      });
    },
    getDataOfCurrentList: function (val, oldVal) {
      if (val.data.type == "ALL" && this.getTextSearchInput == "") {
        this.items[1].enabled = false;
      } else this.items[1].enabled = true;
    },
    getTextSearchInput: function (val, oldVal) {
      if (this.getDataOfCurrentList.data.type == "ALL" && val == "") {
        this.items[1].enabled = false;
      } else this.items[1].enabled = true;
    },
    hasCheckedBooks: function (val, oldVal) {
      this.items[2].enabled = val;
    },
    getListCheckBooksFree: function (val, oldVal) {
      if (JSON.stringify(val) == JSON.stringify(oldVal)) return;
      if (this.hasCheckedBooks) {
        if (
          this.freeSearchBookListStore.searchInType !==
          this.enumSearchInType.selected
        ) {
          this.freeSearchBookListStore.setPrevSearchInType(
            this.freeSearchBookListStore.searchInType
          );

          this.freeSearchBookListStore.prevSearchInBooks =
            this.freeSearchBookListStore.searchInBooks;
          this.freeSearchBookListStore.setSearchInType(
            this.enumSearchInType.selected
          );
        } else
          this.freeSearchBookListStore.setSearchInType(
            this.enumSearchInType.selected
          );
      } else {
        this.freeSearchBookListStore.setSearchInType(
          this.freeSearchBookListStore.prevSearchInType
        );
        this.freeSearchBookListStore.resetBooksToSearchIn();
      }
    },

    getCheckedBooks: function (val, oldVal) {
      if (JSON.stringify(val) == JSON.stringify(oldVal)) return;
      if (this.hasCheckedBooks) {
        if (
          this.freeSearchBookListStore.searchInType !==
          this.enumSearchInType.selected
        ) {
          this.freeSearchBookListStore.setPrevSearchInType(
            this.freeSearchBookListStore.searchInType
          );

          this.freeSearchBookListStore.prevSearchInBooks =
            this.freeSearchBookListStore.searchInBooks;
          this.freeSearchBookListStore.setSearchInType(
            this.enumSearchInType.selected
          );
        } else
          this.freeSearchBookListStore.setSearchInType(
            this.enumSearchInType.selected
          );
      } else {
        this.freeSearchBookListStore.setSearchInType(
          this.freeSearchBookListStore.prevSearchInType
        );
        this.freeSearchBookListStore.resetBooksToSearchIn();
      }
    },
  },
};
</script>

<style scoped lang="scss">
$bg-color1: #fff;
$text-color1: #000;
.FSFilterCombo {
  height: 32px;
  display: flex;
  border: 0;
  background-color: $bg-color1;
  cursor: pointer;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  width: 100%;
  min-width: 74px;
  // margin-left: 17px;
  //  height: 30.54px;
  text-align: right;
  line-height: auto;
  direction: rtl;
  position: relative;
  flex-direction: row;
  line-height: initial;
  align-items: center;
  &:hover {
  }
  &.FilterComboFocus {
    .selected-text {
      font-weight: 400;
      transition: 0.3s;
      // border-right: 1px solid #e5e5e5;
    }
  }
  .selected-text {
    transition: 0.3s;
    // border-right: 1px solid #e5e5e5;
  }
}
.FilterComboFocus {
  border-color: gray;
  &:active {
    background-color: #f3f3f3;
  }
}
.arrow-down-col {
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: #00000000;
  /* position: absolute; */
  /* left: 5px; */
  margin-right: 4px;
  position: relative;
  transition: 0.3s;
  &:hover,
  &.open {
    background-color: #00000020;
    transition: 0.3s;
  }
  svg {
    display: block;
    transition: 0.3s;
    position: absolute;
    top: 4.2px;
    left: 2.8px;
    // transform: translateX(-50%) translateY(-50%);
  }
}
.arrow-down-col.open svg {
  transform: rotate(180deg);
  transition: 0.3s;
}

.selected-text {
  // height: 20px;
  padding-right: 12px;
  font-size: 13px;
  text-align: right;
  width: calc(100% - 16px);
  // color: $text-color1;
}
// .option-items {
//   display: none;
//   position: relative;
//   z-index: 2;
//   text-align: right;
//   background-color: #fff;
//   box-shadow: 3px 3px 6px #00000016;
// }
.option-items-grid {
  display: none;
  position: absolute;
  flex-direction: row;
  z-index: 2;
  background-color: $bg-color1;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  left: 0px;
  top: 100%;
  width: 256px;
  flex-wrap: wrap;
}
.open-menu {
  display: block;
  width: 100%;
  top: 100%;
  position: absolute;
  width: fit-content;
  min-width: 100%;
}
.open-menu-grid {
  display: flex;
  width: 256px;
  left: -50%;
  top: 100%;
  position: absolute;
}
.combo-item {
  // text-align: right;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  padding: 0 8px;
  white-space: nowrap;
  // overflow: hidden;
}

.combo-item-grid {
  height: 30px;
  width: 30px;
  align-self: flex-start;
  border-style: solid;
  border-width: 1px;
  border-color: #f5f5f5;
  font-size: 14px;
  text-align: center;
  display: table;
}

.label-option {
  display: table-cell;
  vertical-align: middle;
}
.label-option:hover {
  background-color: #dedede;
}
.filter {
  padding: 15px 0 10px 10px;
  height: 100%;
  padding: 0;
  width: 110px;
  border-left: 1px solid #e5e5e5;
  .FSFilterCombo .selected-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.disable {
  opacity: 0.3;
  cursor: default !important;
}
.custom-item {
  color: var(--custom-color1);
  &:hover {
    .remove-item {
      opacity: 1;
    }
  }
}
.remove-item {
  font-size: 7px;
  opacity: 0;
  padding-right: 5px;
}
</style>
